import Client from './HTTPClient';

const API = {
  list (request) {
    return Client.post('/api/regions/', request);
  },

  create (request) {
    return Client.post('/api/regions/new', request);
  }
};

export default API;
